module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "toc"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_Ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack#ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PART ONE:")]), _vm._v(" Children Of The Grave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("One: I, Awake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Two: The Devil’s Interval")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three: Bringers of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four: Pope On A Rope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five: Killing Yourself To Live")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six: Born To Die")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_pt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PART TWO:")]), _vm._v(" Unlucky For Some")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven: Neon Nights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight: Train Wreck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine: Mob Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten: Upside Down Crosses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven: Dehumanised")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve: Saviour")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen: 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1#photo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_Not"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/sou#sou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes and Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_Als"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#ad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Mick Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0